export const paymentProcessors = {
    braintree: "Braintree",
    payeezy: "Payeezy",
    shift4: "Shift4",
    authorizeNet: "AuthorizeNet"
}